// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  display: flex;
  flex-direction: column;
  width: 223px;
  justify-content: space-between;
  padding: 0;
}
.content .header {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 16px 16px 0;
}
.content .actions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px !important;
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.reorderContainer {
  margin: 0px 10px 0px 0px !important;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
}
.reorderContainer .filler {
  width: 23.5%;
}
.reorderContainer .workbook {
  display: flex;
  flex-direction: column;
  height: 118px;
  width: 12.7vw;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(33, 8, 84, 0.04);
  z-index: 30;
  margin: 9px 5px 0px !important;
}
.reorderContainer .workbook .example-handle {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.reorderContainer .workbook .example-handle .mat-card-header {
  text-align: left;
}
.reorderContainer .workbook .example-handle .mat-card-header .mat-card-header-text {
  margin: 0 0px !important;
}
.reorderContainer .workbook .example-handle .cdk-drag-handle mdc-button__label {
  color: #ffb5a0 !important;
}
.reorderContainer > td {
  width: 20% !important;
  padding-right: 9px !important;
  padding-bottom: 9px !important;
}
.reorderContainer > td.filler {
  margin: 0 !important;
}
.reorderContainer > td.filler > .workbook {
  margin: 0 !important;
}
.reorderContainer > td > div {
  width: 100%;
  margin: 0 !important;
}

.mat-mdc-card-actions.actions {
  margin: 0;
  padding: 0;
  height: unset;
  padding: 0;
  height: 40px;
}
.mat-mdc-card-actions.actions .begin-btn {
  height: 20px;
  line-height: unset;
  padding: 0;
  min-width: 50px;
  color: #866dff;
  font-size: 14px;
  font-weight: 500;
}
.mat-mdc-card-actions.actions .more-options {
  transform: scale(0.8);
  color: rgba(165, 155, 155, 0.3) !important;
}

.mat-mdc-card > .mat-mdc-card-actions:last-child {
  margin-bottom: 2px;
}

.new-workbook {
  font-size: 14px;
  font-weight: 500;
  margin: 9px 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/core/styles/workbook-cards.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,8BAAA;EACA,UAAA;AAFJ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AADR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;AADR;;AAsBE;EACE,UAAA;AAnBJ;;AAsBE;EACE,sDAAA;AAnBJ;;AAsBE;EACE,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EA4CA,WAAA;AA9DJ;AAmBI;EACE,YAAA;AAjBN;AAoBI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EAEA,kBAAA;EACA,6CAAA;EACA,WAAA;EAEA,8BAAA;AApBN;AAqBQ;EACE,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AAnBV;AAoBU;EAEE,gBAAA;AAnBZ;AAoBY;EACE,wBAAA;AAlBd;AAsBY;EACE,yBAAA;AApBd;AAkCI;EACE,qBAAA;EACA,6BAAA;EACA,8BAAA;AAhCN;AAiCM;EACE,oBAAA;AA/BR;AAgCQ;EACE,oBAAA;AA9BV;AAiCM;EACE,WAAA;EACA,oBAAA;AA/BR;;AAuCA;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;AApCF;AAqCE;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnCJ;AAqCE;EACE,qBAAA;EACA,0CAAA;AAnCJ;;AAuCA;EACE,kBAAA;AApCF;;AAuCA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AApCF","sourcesContent":["// @import \"../../styles.scss\";\n// @import \"../../component_variable.scss\";\n.content {\n    display: flex;\n    flex-direction: column;\n    width: 223px;\n    // padding: 17px 16px;\n    justify-content: space-between;\n    padding: 0;\n    .header {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        padding: 16px 16px 0;\n    }\n    .actions {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        padding-left: 10px !important;\n        // padding: 0 8px !important;\n        // margin-bottom: 5% !important;\n        // .begin-button {\n        //     width: 59px !important;\n        // }\n        // .ellipsis {\n        //     width: 24px !important;\n        // }\n    }\n\n}\n\n  // .cdk-drag-preview {\n  //   box-sizing: border-box;\n  //   border-radius: 4px;\n  //   box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n  //               0 8px 10px 1px rgba(0, 0, 0, 0.14),\n  //               0 3px 14px 2px rgba(0, 0, 0, 0.12);\n  // }\n\n  .cdk-drag-placeholder {\n    opacity: 0;\n  }\n\n  .cdk-drag-animating {\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n  }\n\n  .reorderContainer{\n    margin: 0px 10px 0px 0px !important;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    .filler {\n      width: 23.5%;\n\n    }\n    .workbook{\n      display: flex;\n      flex-direction: column;\n      height: 118px;\n      width: 12.7vw;\n\n      border-radius: 8px;\n      box-shadow: 0 4px 8px 0 rgba(33, 8, 84, 0.04);\n      z-index: 30;\n      // background-color: $primary-dark-background-color !important;\n      margin: 9px 5px 0px !important;\n        .example-handle{\n          display: flex;\n          justify-content: flex-start;\n          flex-direction: column;\n          height: 100%;\n          width: 100%;\n          .mat-card-header {\n            // color: $primary-dark;\n            text-align: left;\n            .mat-card-header-text {\n              margin: 0 0px !important;\n            }\n          }\n          .cdk-drag-handle{\n            mdc-button__label{\n              color: #ffb5a0 !important;\n            }\n          }\n        }\n      // &.draggable-source--is-dragging {\n      //   .mat-icon-button.ellipsis {\n      //     img {\n      //       filter: invert(1);\n      //     }\n      //   }\n      // }\n\n    }\n    width: 100%;\n    > td {\n      width: 20% !important;\n      padding-right: 9px !important;\n      padding-bottom: 9px !important;\n      &.filler {\n        margin: 0 !important;\n        > .workbook {\n          margin: 0 !important;\n        }\n      }\n      > div {\n        width: 100%;\n        margin: 0 !important;\n      }\n    }\n  }\n\n.reorderContainer {\n}\n\n.mat-mdc-card-actions.actions {\n  margin: 0;\n  padding: 0;\n  height: unset;\n  padding: 0;\n  height: 40px;\n  .begin-btn {\n    height:20px;\n    line-height: unset;\n    padding: 0;\n    min-width: 50px;\n    color: #866dff;\n    font-size: 14px;\n    font-weight: 500;\n  }\n  .more-options {\n    transform: scale(0.8);\n    color: rgba(165, 155, 155, 0.3) !important;\n  }\n}\n\n.mat-mdc-card>.mat-mdc-card-actions:last-child {\n  margin-bottom: 2px;\n}\n\n.new-workbook {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 9px 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
